import { makeStyles } from '@material-ui/core/styles';

const SupportedByStyles =
    makeStyles((theme) => ({
        mainSupportedByStyles: {
            textAlign: "center",
            padding: "20px",
            color: theme.palette.text.secondary,
        },
        supportedByTitle: {
            margin: theme.spacing(3),
        },
        supportersContainer: {
            display: "flex",
            columnGap: theme.spacing(4),
            alignItems: "center",
            justifyContent: "center",
            marginTop: `-${theme.spacing(8)}px`,
        },
        supporterColumn: {
            display: "grid",
        }
}));

export default SupportedByStyles;